import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import randomColor from 'randomcolor';
import { Container, Grid, Card, TextField, Button, Checkbox, Box, Typography, Switch } from '@material-ui/core';
import { Save } from '@material-ui/icons';
import { evaluationTeamsActions, ideaStepFluxActions } from '../../actions';
import { BackNavAdmin, LoadingButton } from '../../components';
import { MultiSelect } from '../../components';
import { useStyles } from './styles';

function IdeaStepFluxNewPage() {
  const classes = useStyles();
  const { id } = useParams();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const ideaStepFlux = useSelector((state) => state.ideaStepFlux);
  const { teams } = useSelector(state => state.evaluationTeams);
  const { ideasStepsFlux } = useSelector((state) => state.domains);
  const isEdit = id !== undefined && id !== null;
  const stepData = ideasStepsFlux.some(item => item._id === id);
  const teamsFiltered = teams.filter(item => ideaStepFlux.evaluationTeams.includes(item._id))

  useEffect(() => {
    return () => {
      dispatch(ideaStepFluxActions.clearIdeaStepFluxData())
    }
  }, [dispatch]);

  useEffect(() => {
    if (isEdit && stepData) {
      dispatch(ideaStepFluxActions.loadStepDetails(ideasStepsFlux.filter(item => item._id === id)[0]));
    }
  }, [isEdit, ideasStepsFlux, stepData]);

  useEffect(() => {
    if (ideasStepsFlux && ideasStepsFlux.length > 0) {
      dispatch(ideaStepFluxActions.setIdeaStepFluxData({
        ...ideaStepFlux,
        ideaFlux: ideasStepsFlux[0].ideaFlux,
        labelColor: randomColor()
      }));
    }
  }, [dispatch]);

  useEffect(() => {
    dispatch(evaluationTeamsActions.getAllEvaluationTeams());
  }, []);

  function handleSend() {
    if (isEdit) {
      dispatch(ideaStepFluxActions.editIdeaStepFlux(ideaStepFlux));
    } else {
      dispatch(ideaStepFluxActions.createIdeaStepFlux(ideaStepFlux));
    }
  }

  function onChangeText({ target: { value, name } }) {
    dispatch(ideaStepFluxActions.setNewContent({ name, value }));
  }

  function onChangeSwitch({ target: { checked, name } }) {
    dispatch(ideaStepFluxActions.setNewContentSwitch({ name, checked }));
  }

  function onChangeSwitchEvaluation({ target: { checked, name } }) {
    dispatch(ideaStepFluxActions.setEvaluationLevel({ name, checked }));
  }

  function onChangeSwitchNotification({ target: { checked, name } }) {
    dispatch(ideaStepFluxActions.setNotificationControls({ name, checked }));
  }

  function onChangeDecisionText({ target: { value, name } }) {
    dispatch(ideaStepFluxActions.setDecisionName({ typeDecision: name, value }));
  }

  function handleTeamsSelect(event) {
    dispatch(ideaStepFluxActions.setNewContent({ name: 'evaluationTeams', value: event }));
  }

  function validateDisabled () {
    const isValidDecisionOne = ideaStepFlux.decisions && ideaStepFlux.decisions[0] && ideaStepFlux.decisions[0].title;
    const isValidDecisionTwo = ideaStepFlux.decisions && ideaStepFlux.decisions[1] && ideaStepFlux.decisions[1].title;
    
    return ideaStepFlux.loading || !isValidDecisionOne || !isValidDecisionTwo || !ideaStepFlux.name;
  }

  const CheckboxCustom = ({ name, checked, onChange, label }) => (
    <Box className={classes.checkbox}>
      <Checkbox
        name={name}
        onChange={onChange}
        checked={checked}
        color="primary"
      />
      <Typography className={classes.checkboxText}>{label}</Typography>
    </Box>
  );

  return (
    <>
      <BackNavAdmin title={isEdit ? t('update_idea_step_flux') : t('new_idea_step_flux')} pathname="/preferences/flux-of-ideas" />
      <Container maxWidth="lg" className={classes.root}>
        <Card elevation={0} className={classes.card}>
          <Grid container spacing={4}>
            <Grid item xs={6}>
              <TextField
                name="name"
                label={t('step_name')}
                type="text"
                fullWidth
                variant="filled"
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                  },
                }}
                value={ideaStepFlux.name}
                onChange={onChangeText}
              />
            </Grid>
            <Grid item xs={12}>
              <Box className={classes.stateContainer}>
                <Typography className={classes.stateTitle}>
                  {t('arquivos_necessarios_aprovacao')}
                </Typography>
                <Switch
                  checked={ideaStepFlux.attachmentsRequired}
                  onChange={onChangeSwitch}
                  name="attachmentsRequired"
                  color="primary"
                  size="small"
                />
                <Typography className={classes.state}>
                  {ideaStepFlux.attachmentsRequired ? t('sim') : t('nao')}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box className={classes.stateContainer}>
                <Typography className={classes.stateTitle}>
                  {t('opcao_ideia_timeline')}
                </Typography>
                <Switch
                  checked={ideaStepFlux.optionIdeiaInTimeline}
                  onChange={onChangeSwitch}
                  name="optionIdeiaInTimeline"
                  color="primary"
                  size="small"
                />
                <Typography className={classes.state}>
                  {ideaStepFlux.optionIdeiaInTimeline ? t('sim') : t('nao')}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box className={classes.stateContainer}>
                <Typography className={classes.stateTitle}>
                  {t('aprovacao_na_etapa')}
                </Typography>
                <Switch
                  checked={ideaStepFlux.approveInStepConcludeIdea}
                  onChange={onChangeSwitch}
                  name="approveInStepConcludeIdea"
                  color="primary"
                  size="small"
                />
                <Typography className={classes.state}>
                  {ideaStepFlux.approveInStepConcludeIdea ? t('sim') : t('nao')}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={6}>
              <Box className={classes.stateContainer}>
                <Typography className={classes.stateTitle}>
                  {t('reprovacao_na_etapa')}
                </Typography>
                <Switch
                  checked={ideaStepFlux.rejectInStepConcludeIdea}
                  onChange={onChangeSwitch}
                  name="rejectInStepConcludeIdea"
                  color="primary"
                  size="small"
                />
                <Typography className={classes.state}>
                  {ideaStepFlux.rejectInStepConcludeIdea ? t('sim') : t('nao')}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Box className={classes.stateContainer}>
                <Typography className={classes.stateTitle}>
                  {t('colaborador_editar_ideia')}
                </Typography>
                <Switch
                  checked={ideaStepFlux.canEditIdea}
                  onChange={onChangeSwitch}
                  name="canEditIdea"
                  color="primary"
                  size="small"
                />
                <Typography className={classes.state}>
                  {ideaStepFlux.canEditIdea ? t('sim') : t('nao')}
                </Typography>
              </Box>
            </Grid>
          </Grid>

          <Grid container spacing={4}>
            <Grid item xs={6}>
              <TextField
                id="NextStepApproved"
                name="NextStepApproved"
                label={t('nome_botao_aprovacao')}
                type="text"
                fullWidth
                variant="filled"
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                  },
                }}
                value={ideaStepFlux.decisions.filter(item => item.typeDecision === 'NextStepApproved')[0]?.title || ''}
                onChange={onChangeDecisionText}
              />
            </Grid>

            <Grid item xs={6}>
              <TextField
                id="NextStepRejected"
                name="NextStepRejected"
                label={t('nome_botao_reprovar')}
                type="text"
                fullWidth
                variant="filled"
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                  },
                }}
                value={ideaStepFlux.decisions.filter(item => item.typeDecision === 'NextStepRejected')[0]?.title || ''}
                onChange={onChangeDecisionText}
              />
            </Grid>
          </Grid>
        </Card>

        <Grid container className={classes.marginTopHigh}>
          <Grid item xs={12}>
            <Card elevation={0} className={classes.card}>
              <Typography className={classes.stateTitle}>
                {t('selecione_quem_pode_avaliar_nesta_etapa')}
              </Typography>
              <CheckboxCustom
                name="canDirectManagerEvaluateStep"
                checked={ideaStepFlux.evaluationLevel?.canDirectManagerEvaluateStep}
                onChange={onChangeSwitchEvaluation}
                label={t('gestor_direto_pode_avaliar')}
              />
              <CheckboxCustom
                name="canAreaManagerEvaluateStep"
                checked={ideaStepFlux.evaluationLevel.canAreaManagerEvaluateStep}
                onChange={onChangeSwitchEvaluation}
                label={t('gestor_area_pode_avaliar')}
              />
              <CheckboxCustom
                name="canOriginAreaManagerEvaluateStep"
                checked={ideaStepFlux.evaluationLevel.canOriginAreaManagerEvaluateStep}
                onChange={onChangeSwitchEvaluation}
                label={t('gestor_area_origem_pode_avaliar')}
              />
              <CheckboxCustom
                name="teamAndAreaManagerEvaluateStep"
                checked={ideaStepFlux.evaluationLevel.teamAndAreaManagerEvaluateStep}
                onChange={onChangeSwitchEvaluation}
                label={t('time_de_avaliacao_e_gestor_area')}
              />
              <Box className={classes.checkbox}>
                <Typography className={classes.checkboxText}>
                  {t('time_de_avaliacao_aprovacao')}
                </Typography>

                <MultiSelect items={teams} defaultValues={teamsFiltered} id='teams' onChange={handleTeamsSelect}/>
              </Box>
            </Card>
          </Grid>
        </Grid>

        <Grid container className={classes.marginTopHigh}>
          <Grid item xs={12}>
            <Card elevation={0} className={classes.card}>
              <Typography className={classes.stateTitle}>
                {t('selecione_niveis_de_notificacao')}
              </Typography>
              <CheckboxCustom
                name="notifyDirectManagerWhenDecision"
                checked={ideaStepFlux.notificationsControl?.notifyDirectManagerWhenDecision}
                onChange={onChangeSwitchNotification}
                label={t('notificar_gestor_direto')}
              />
              <CheckboxCustom
                name="notifyAreaManagersWhenDecision"
                checked={ideaStepFlux.notificationsControl?.notifyAreaManagersWhenDecision}
                onChange={onChangeSwitchNotification}
                label={t('notificar_gestor_da_area')}
              />
              <CheckboxCustom
                name="notifyEvaluationTeamsWhenDecision"
                checked={ideaStepFlux.notificationsControl?.notifyEvaluationTeamsWhenDecision}
                onChange={onChangeSwitchNotification}
                label={t('notificar_time_de_avaliacao')}
              />
              <CheckboxCustom
                name="notifyIdeaContributorsWhenDecision"
                checked={ideaStepFlux.notificationsControl?.notifyIdeaContributorsWhenDecision}
                onChange={onChangeSwitchNotification}
                label={t('notificar_contribuidores_ideia')}
              />
              <CheckboxCustom
                name="notifyEvaluatorsWhenNewPending"
                checked={ideaStepFlux.notificationsControl?.notifyEvaluatorsWhenNewPending}
                onChange={onChangeSwitchNotification}
                label={t('notificar_avaliadores_ideia')}
              />
            </Card>
          </Grid>

          <Grid item xs={12} className={classes.marginTopHigh}>
            {ideaStepFlux.loading ? <LoadingButton /> : (
              <Button
                variant="contained"
                color="primary"
                startIcon={<Save />}
                onClick={handleSend}
                disabled={validateDisabled()}
              >
                {isEdit ? t('update_idea_step_flux') : t('save_step')}
              </Button>
            )}
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export { IdeaStepFluxNewPage };